import axios from 'axios';
import Cookies from 'js-cookie'
import AccessToken from '@/services/auth-tenant';

var CryptoJS = require("crypto-js");
const ACCESS_TOKEN = AccessToken();
let wmsUrl = process.env.WMS_URL;
let wmsServiceId = Cookies.get('wmsServiceId');

let config = {};

const signature = (queryString = "") => {
  delete axios.defaults.headers.common["Authorization"];
  const CryptoJS = require("crypto-js");
  const jsx = require("js-extension-ling");

  const params = jsx.queryStringToObject(queryString);

  const key = process.env.WMS_APP_KEY;
  const partnerAppSecret = process.env.WMS_APP_SECRET;
  const storeId = wmsServiceId; // เพิ่ม APP_STORE_ID
  const timestamp = new Date().getTime();

  let query = Object.entries(params).reduce((acc, [k, v]) => {
      if (v) acc[k] = v;
      return acc;
  }, {});

  query = {
      ...query,
      key,
      store: storeId, // เพิ่ม APP_STORE_ID เข้าใน query
      timestamp
  };

  let baseString = `secret=${partnerAppSecret}`;
  for (const key of Object.keys(query).sort()) {
      if (Array.isArray(query[key])) {
          for (const value of query[key]) {
              baseString += `${key}[]=${value}`;
          }
      } else if (typeof query[key] === "object" && query[key] !== null) {
          const values = Object.values(query[key]);
          for (const value of values) {
              baseString += `${key}[]=${value}`;
          }
      } else {
          baseString += `${key}=${query[key]}`;
      }
  }

  const hmac = CryptoJS.HmacSHA256(baseString, partnerAppSecret);
  const signature = hmac.toString(CryptoJS.enc.Hex);

  query = { ...query, signature };

  return '?' + new URLSearchParams(query).toString();
};

class Signature {
  create(query){
    return signature(query);
  }
}

const API_ADJUSTMENTS_GETWAREHOUSE = '/v1/warehouses'
// const API_INVENTORY_GETPRODUCT = '/v2/inventories/adjustments/warehouses'
const API_INVENTORY_GETPRODUCT = '/v1/warehouses'
const API_REPORT_GETPRODUCT = '/v1/products'
const API_REPORT_CHANNEL = '/v1/channels'



class Transfer {
  async getTransferList(queryString = "") {
    const response = await axios.get(wmsUrl + '/v1/transfers' + signature(queryString), config);
    return response;
  }
  async getWarehouses(queryString) {
    const response = await axios.get(wmsUrl + '/v1/warehouses' + signature(queryString), config);
    return response;
  }
  async createTransafer(data,queryString='') {
    const response = await axios.post(wmsUrl + '/v1/transfers'+ signature(queryString), data, config)
        .then(response => {
            return response;
        }).catch(function (error) {
            if (error.response) {
                return error.response;
            }
        });
    return response;
  }
  async getTransferById(purchaseId) {
    const response = await axios.get(wmsUrl + '/v1/transfers/' + purchaseId + signature(), config);
    return response;
  }
  async cancelTransfer(transferId, data) {
    const response = await axios.post(wmsUrl + '/v1/transfers/' + transferId + '/cancel' + signature(), data, config);
    return response
  }
  async getActivitiesLog(activitieId, options = {}) {
    try{
    const response = await axios.get(wmsUrl + '/v1/transfers/' + activitieId + '/logs' + signature(), config);
    return response;

    } catch (err) {
    if (err.response.status !== 403) {
        handleApi(err);
    }
    return err.response;
    }
  }
  async getProductPromotion(warehouseId, queryString) {
    const response = await axios.get(wmsUrl + '/v1/warehouses/' + warehouseId + '/products' + signature(queryString), config);
    return response
  }
}

class Report {
  async getInventoryList(queryString = "") {
    const response = await axios.get(wmsUrl + '/v1/report/inventory' + signature(queryString), config);
    return response;
  }
  async getStockAgingList(queryString = "") {
    const response = await axios.get(wmsUrl + '/v1/report/stock-aging' + signature(queryString), config);
    return response;
  }
}

class Purchase {
  async createNote(data,queryString='') {
    const response = await axios.post(wmsUrl + '/v1/notes'+ signature(queryString), data, config)
      .then(response => {
        return response;
      }).catch(function (error) {
          if (error.response) {
            return error.response;
          }
      });
    return response;
  }
  async deleteNote(noteId, data) {
    const response = await axios.delete(wmsUrl + '/v1/notes/' + noteId + signature(), {data: data}, config);
    return response
  }
  async updateNote(data, noteId) {
    const response = await axios.put(wmsUrl + '/v1/notes/' + noteId + signature(), data, config);
    return response;
  }
}



export default {
  Signature: new Signature(),
  AUTH: {
    URL: wmsUrl,
    TOKEN: ACCESS_TOKEN.token
  },
  URL: {
    ADJUSTMENTS_GETWAREHOUSE: API_ADJUSTMENTS_GETWAREHOUSE,
    INVENTORY_GETPRODUCT: API_INVENTORY_GETPRODUCT,
    REPORT_GETPRODUCT: API_REPORT_GETPRODUCT,
    REPORT_CHANNEL: API_REPORT_CHANNEL
  },
  Transfer: new Transfer(),
  Report: new Report(),
  Purchase: new Purchase(),
};




// WEBPACK FOOTER //
// ./src/services/endpoint/wms.service.js